export const ru = {
    main_info: 'Основная информация',
    main_info_desc: 'Нужна для оформления командировок',
    contact_info: 'Контактная информация',
    contact_info_desc: 'Нужна для связи в командировке и оформления такси',
    save_changes_desc: 'Изменения будут действовать только в новых заявках',
    changes_saved: 'Изменения сохранены',
    change_user: 'Сменить пользователя',
};
